export const BUSINESS_ICON = "business"
export const CORPORATION_ICON = "corporation"
export const LICENSE_ICON = "license"
export const CALENDAR_ICON = "calendar"
export const DESCRIPTION_ICON = "description"
export const LINK_ICON = "link"
export const LOCATION_ICON = "location"
export const PEOPLE_ICON = "people"
export const PERSON_ICON = "person"
export const TIME_ICON = "time"
export const UPLOAD_ICON = "upload"
export const SOCIAL_FACEBOOK_ICON = "social-facebook"
export const SOCIAL_GITHUB_ICON = "social-github"
export const SOCIAL_LINKED_IN_ICON = "social-linked-in"
export const SOCIAL_TWITTER_ICON = "social-twitter"

export type IconType =
  | typeof BUSINESS_ICON
  | typeof CORPORATION_ICON
  | typeof LICENSE_ICON
  | typeof CALENDAR_ICON
  | typeof DESCRIPTION_ICON
  | typeof LINK_ICON
  | typeof LOCATION_ICON
  | typeof PEOPLE_ICON
  | typeof PERSON_ICON
  | typeof TIME_ICON
  | typeof UPLOAD_ICON
  | typeof SOCIAL_FACEBOOK_ICON
  | typeof SOCIAL_GITHUB_ICON
  | typeof SOCIAL_LINKED_IN_ICON
  | typeof SOCIAL_TWITTER_ICON
